import script from "./vi-table.vue?vue&type=script&lang=ts&setup=true"
export * from "./vi-table.vue?vue&type=script&lang=ts&setup=true"

import "./vi-table.vue?vue&type=style&index=0&id=646f6aef&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-646f6aef"]])

export default __exports__